import axios from 'axios';
import DOMPurify from 'dompurify';
import draftToHtml from 'draftjs-to-html';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import DatePickerRange from '../DatePickerRange/DatePickerRange';
import ImageCoverUploader from '../ImageCoverUploader/ImageCoverUploader';
import ImageUploader from '../ImageUploader/ImageUploader';
import RichTextEditor from '../RichTextEditor/RichTextEditor';
import EmployeeVisibilityDropdown from '../VisibilityDropdown/EmployeeVisibilityDropdown';
import { EntityList } from '../VisibilityDropdown/EntityList';
import EntityVisibilityDropdown from '../VisibilityDropdown/EntityVisibilityDropdown';
import './Bulletin.css';

const AddBulletin = (props) => {
    const [title, setTitle] = useState('');
    const [htmlContent, setHtmlContent] = useState('');
    const [employee, setEmployee] = useState('');
    const [image, setImage] = useState('');
    const [imageCover, setImageCover] = useState('');
    const [displayImage, setDisplayImage] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [createdBy, setCreatedBy] = useState('');
    const [displayPostDate, setDisplayPostDate] = useState('');
    const [displayPostTime, setDisplayPostTime] = useState('');

    const [selectedEntity, setSelectedEntity] = useState([]);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    const options = EntityList;

    useEffect(() => {
        setCreatedBy(localStorage.getItem('badgeID'));

        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes('Bulletin Board') &&
                        item.permissionType.includes('edit'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            }
        }
    }, [props.loginList]);

    const getContent = (htmlContentProp) => {
        setHtmlContent(draftToHtml(htmlContentProp));
    };

    const getEmployeeVisibility = (employeeVisibilityProp) => {
        let newEmployee = employeeVisibilityProp.toString();
        setEmployee(newEmployee);
    };

    const getImageUrl = (uuidFileName, signedUrl) => {
        setImage(uuidFileName);
        setDisplayImage(signedUrl);
    };

    const getImageCoverUrl = (uuidFileName) => {
        setImageCover(uuidFileName);
    };

    const getStartTime = (startTimeProp) => {
        setStartDate(moment(startTimeProp).format('YYYY-MM-DD HH:mm'));
        // Set the display start time at mobile preview section
        setDisplayStartTime(startTimeProp);
    };

    const setDisplayStartTime = (displayStartTime) => {
        setDisplayPostDate(moment(displayStartTime).format('DD MMMM'));
        setDisplayPostTime(moment(displayStartTime).format('hh:mm A'));
    };

    const getEndTime = (endTimeProp) => {
        setEndDate(moment(endTimeProp).format('YYYY-MM-DD HH:mm'));
    };

    const createMarkup = (html) => {
        return {
            __html: DOMPurify.sanitize(html, {
                ADD_TAGS: ['iframe'],
                ADD_ATTR: [
                    'allow',
                    'allowfullscreen',
                    'frameborder',
                    'scrolling',
                ],
            }),
        };
    };

    const history = useHistory();

    // Add Bulletin
    const addBulletin = async (bulletin) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/addbulletin';
        const bulletinDetails = {
            title: bulletin.title,
            desc: bulletin.desc,
            image: bulletin.image,
            imageCover: bulletin.imageCover,
            employee: bulletin.employee,
            entity: bulletin.entity,
            startDate: bulletin.startDate,
            endDate: bulletin.endDate,
            createdBy: bulletin.createdBy,
        };
        axios
            .post(url, bulletinDetails)
            .then(
                (response) => 
                alert('Bulletin has been successfully created!'),
                setTimeout(() => {
                    history.push('/bulletinboard');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };
    
    function fixedEncodeURIComponent(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16);
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();

        if (!title) {
            alert('Please enter a title');
        } else if (!htmlContent) {
            alert('Please enter your description');
        } else if (!employee) {
            alert('Please select an employee type');
        } else if (selectedEntity.length === 0) {
            alert('Please select an entity type');
        } else if (!image) {
            alert('Please upload an image first');
        } else if (startDate === endDate) {
            alert(
                'End date and time cannot be the same with start date and time!'
            );
        } else if (startDate > endDate) {
            alert('Start date/time cannot be greater than start date/time!');
        } else {
            // const desc = encodeURIComponent(htmlContent.replace(/'/g, "''"));
            const desc = fixedEncodeURIComponent(htmlContent)
            const entity = selectedEntity.map((x) => x.value).toString();

            addBulletin({
                title,
                desc,
                employee,
                entity,
                image,
                imageCover,
                startDate,
                endDate,
                createdBy,
            });
        }
    };

    return (
        <div className='main-hero-container'>
            <div
                className={`${
                    props.isActive ? 'container is-active' : 'container'
                }`}
            >
                <Row>
                    <h1>Create Bulletin</h1>
                    <Col xs={12} md={8}>
                        <form className='add-form' onSubmit={onSubmit}>
                            <div className='form-control bulletin'>
                                <label>Title</label>
                                <input
                                    type='text'
                                    placeholder='Insert your title here...'
                                    style={{ width: '100%' }}
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div className='form-control bulletin'>
                                <label>Description</label>
                                <RichTextEditor getContent={getContent} />
                            </div>
                            <div className='form-control bulletin'>
                                <label>Visible To</label>
                                <EmployeeVisibilityDropdown
                                    getEmployeeVisibility={
                                        getEmployeeVisibility
                                    }
                                />
                                <EntityVisibilityDropdown
                                    options={options}
                                    value={selectedEntity}
                                    onChange={setSelectedEntity}
                                />
                            </div>
                            <div className='form-control bulletin'>
                                <label>Upload Image</label>
                                <ImageUploader getImageUrl={getImageUrl} />
                            </div>
                            <div className='form-control bulletin'>
                                <label>
                                    Upload Cover Image (Width 10.65cm x Height
                                    3.75cm)
                                </label>
                                <ImageCoverUploader
                                    getImageCoverUrl={getImageCoverUrl}
                                />
                            </div>
                            <div className='form-control bulletin'>
                                <label>Set Display Date &amp; Time</label>
                                <DatePickerRange
                                    getStartTime={getStartTime}
                                    getEndTime={getEndTime}
                                />
                            </div>
                            <Button as='input' type='submit' value='Submit' />
                            <Link to='/bulletinboard'>
                                <Button variant='outline-primary'>
                                    Cancel
                                </Button>
                            </Link>
                        </form>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className='preview-title-container'>
                            <h5
                                className='text-center'
                                style={{
                                    fontWeight: 'bold',
                                    marginBottom: '0px',
                                }}
                            >
                                Mobile Apps Preview
                            </h5>
                        </div>
                        <Card style={{ borderRadius: '30px', padding: '15px' }}>
                            <div className='flex-container'>
                                {displayPostDate && (
                                    <div className='display-date'>
                                        {displayPostDate}
                                    </div>
                                )}
                                {displayPostTime && (
                                    <span
                                        style={{
                                            alignSelf: 'center',
                                            marginLeft: '5px',
                                        }}
                                    >
                                        {displayPostTime}
                                    </span>
                                )}
                            </div>
                            {displayImage ? (
                                <Card.Img variant='top' src={displayImage} />
                            ) : (
                                <div>[Image will be inserted here]</div>
                            )}
                            <Card.Body>
                                <Card.Title>
                                    <strong>
                                        {title ? title : '[Title will be here]'}
                                    </strong>
                                </Card.Title>
                                <Card.Text>
                                    {htmlContent ? (
                                        <div
                                            dangerouslySetInnerHTML={createMarkup(
                                                htmlContent
                                            )}
                                        />
                                    ) : (
                                        '[Content will be here]'
                                    )}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default AddBulletin;
